const config = {
	// apiUrl: 'http://localhost/maintenance_bck_be/public/',
    // storageUrl: 'http://localhost/maintenance_bck_be/storage/',
    
    apiUrl: 'https://maintenancebe.bck.co.id/public/',
    storageUrl: 'https://maintenancebe.bck.co.id/storage/',
}

export default config